export const GET_FEATURES_KEY = 'GET_FEATURES';
